// extracted by mini-css-extract-plugin
module.exports = {"root":"AriaInfo-root-ac26922b116bd99c170b97a18c17d290"};